import {
  Box,
  Button,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Text,
  VStack,
} from '@chakra-ui/react'
import { useState } from 'react'
import { useEncounterErrors } from '../EncounterErrorsProvider'

// §M.7: Counter banner — replaces single-error orange pill. Shows the number of
// incomplete required (tier-1) fields and, in a popover, the full list. Clicking a
// row scrolls to and highlights the offending field. Renders nothing when there are
// no tier-1 errors.
export const EncounterErrorsBanner = () => {
  const { allTier1Errors, scrollToAndHighlight } = useEncounterErrors()
  const [errorListOpen, setErrorListOpen] = useState(false)

  if (allTier1Errors.length === 0) return null

  return (
    <Box>
      <Popover
        isOpen={errorListOpen}
        onClose={() => setErrorListOpen(false)}
        placement="bottom-start"
        // Don't restore focus to the trigger on close — scrollToAndHighlight
        // moves focus to the clicked field and Chakra would otherwise steal it back.
        returnFocusOnClose={false}
        isLazy>
        <PopoverTrigger>
          {/* Incomplete-field badge — light orange pill (spec 0.6.1 "Incomplete field badge"). */}
          <Button
            variant="unstyled"
            h="auto"
            minW={0}
            fontSize="10px"
            fontWeight={500}
            lineHeight="1.4"
            color="#c0392b"
            bg="#fef0e6"
            border="0.5px solid"
            borderColor="#f0c0a0"
            borderRadius="full"
            px={2}
            py="3px"
            _hover={{ bg: '#fbe0d0' }}
            _dark={{ color: '#c0392b', bg: '#fef0e6' }}
            onClick={() => setErrorListOpen(o => !o)}>
            {allTier1Errors.length} required field
            {allTier1Errors.length !== 1 ? 's' : ''} incomplete — tap to view
          </Button>
        </PopoverTrigger>
        <Portal>
          <PopoverContent w="320px" _dark={{ bg: 'gray.800', borderColor: 'gray.600' }}>
            <PopoverArrow />
            <PopoverBody maxH="300px" overflowY="auto" p={0}>
              <VStack align="stretch" spacing={0}>
                {allTier1Errors.map((err, i) => (
                  <Box
                    key={err.path}
                    px={3}
                    py={2}
                    borderBottom={i < allTier1Errors.length - 1 ? '1px solid' : 'none'}
                    borderColor="gray.100"
                    _dark={{ borderColor: 'gray.700' }}
                    cursor="pointer"
                    _hover={{ bg: 'orange.50', _dark: { bg: 'orange.900' } }}
                    onClick={() => {
                      scrollToAndHighlight(err.path)
                      setErrorListOpen(false)
                    }}>
                    <Text fontSize="sm">{err.text}</Text>
                  </Box>
                ))}
              </VStack>
            </PopoverBody>
          </PopoverContent>
        </Portal>
      </Popover>
    </Box>
  )
}
